export default __webpack_public_path__ + "static/media/img-slider-handigo-1.1fcf9039.png";